module.exports = __webpack_public_path__ + "img/hotel-prince-park.600a115f.jpg";